import * as React from 'react';
import Footer from '../Footer';
import { Header } from '../Header';
import { PageWrapper } from './components/PageWrapper';

import './index.scss';

interface Props {
  isAccount?: boolean;
}

export const Layout: React.FC<Props> = ({ children, isAccount }) => {
  return (
    <div className="container">
      <div className="wrapper">
        <Header />
        <PageWrapper account={isAccount}>{children}</PageWrapper>

        <Footer isBig={isAccount} />
      </div>
    </div>
  );
};
